// Predefined reasons for reporting a product (keep in sync with the mobile app)
export const OTHER_REPORT_REASON = 'Other';

export const PRODUCT_REPORT_REASONS = [
  'Inappropriate or offensive content',
  'Misleading or false product information',
  'Duplicate or spam listing',
  'Copyright or trademark violation',
  'Prohibited or suspicious product',
  OTHER_REPORT_REASON,
];

export const MAX_REPORT_REASON_LENGTH = 500;
